import { default as __WEBPACK_EXTERNAL_MODULE_discourse_routes_discourse_a3344787_default__ } from "discourse/routes/discourse";
import { default as __WEBPACK_EXTERNAL_MODULE__models_admin_plugins_anonymous_email_log_23ae9259_default__ } from "../../models/admin-plugins-anonymous-email-log";
/******/ // The require scope
/******/ var __webpack_require__ = {};
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};

;// external "discourse/routes/discourse"

;// external "../../models/admin-plugins-anonymous-email-log"

;// ./src/plugin/assets/javascripts/discourse/routes/admin-plugins/anonymous-email-log.ts


class AdminAnonymousEmailLogRoute extends __WEBPACK_EXTERNAL_MODULE_discourse_routes_discourse_a3344787_default__ {
    model() {
        return __WEBPACK_EXTERNAL_MODULE__models_admin_plugins_anonymous_email_log_23ae9259_default__.findAll();
    }
}

export { AdminAnonymousEmailLogRoute as default };
